import React from 'react';

/**
 * Bekräftelsedialog för att godkänna en offert åt kunden (BK).
 * Används t.ex. när kunden ringt och accepterat muntligt.
 */
const AcceptOnBehalfConfirmModal = ({ isOpen, onConfirm, onClose, loading = false, customerName }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center p-0 sm:p-4 z-[9999]">
      <div className="bg-white rounded-t-2xl sm:rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-5 sm:p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
              <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900">
              Godkänn offert åt kund
            </h3>
          </div>
          <p className="text-gray-600 mb-2">
            Är du säker på att du vill godkänna offerten{customerName ? <> åt <strong>{customerName}</strong></> : ' åt kunden'}?
          </p>
          <p className="text-gray-500 text-sm mb-6">
            Offerten markeras som godkänd (samma som om kunden själv godkänt) och kunden får en notis. Konvertering till projekt görs separat.
          </p>
          <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 sm:gap-3">
            <button
              onClick={onClose}
              disabled={loading}
              className="px-2.5 py-1.5 sm:px-3 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Avbryt
            </button>
            <button
              onClick={onConfirm}
              disabled={loading}
              className="px-2.5 py-1.5 sm:px-3 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1.5"
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  Godkänner...
                </>
              ) : (
                <>
                  <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  Godkänn åt kund
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcceptOnBehalfConfirmModal;
